module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "view-document",
      "aria-hidden": "true",
      "aria-labelledby": "exampleGrid",
      "role": "dialog"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-simple modal-center"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row header"
  }, [_c('div', {
    staticClass: "col-8"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("\n                " + _vm._s(_vm.$t("booking.detail.resources.view_document_modal.title")) + "\n              ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-4"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.closeModal('#view-document')
      }
    }
  }, [_c('span', {
    staticClass: "close-btn",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "row d-flex justify-content-center align-items-center document-image"
  }, [_c('div', {
    staticClass: "col-8"
  }, [_c('img', {
    attrs: {
      "src": _vm.resource.name,
      "alt": ""
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer text-center"
  }, [_c('a', {
    staticClass: "btn btn-primary waves-effect waves-classic",
    attrs: {
      "href": _vm.resource.name,
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.$t("booking.detail.resources.view_document_modal.view_original")))])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-cf5929f2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/pages/bookings/details/modals/ViewDocumentModal.vue
// module id = 1447
// module chunks = 0